import { motion } from "framer-motion";
import "./AboutSection.css";
import aboutImg from "../../Images/real_estate_homepage.jpg"; // change image if needed
import { FaTrophy, FaHome, FaShieldAlt } from "react-icons/fa";

export default function AboutSection() {
  return (
    <section className="about-section1">
      <div className="about-container">

        {/* LEFT IMAGE */}
        <div className="about-left">
          <img src={aboutImg} alt="Luxury Interior" />

          {/* Floating Card */}
          <motion.div 
            className="award-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <FaTrophy className="award-icon" />
            <h4>National Real Estate Awards</h4>
            <p>Premium Analysis</p>
          </motion.div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="about-right">
          <p className="about-subtitle">ABOUT US</p>

          <h2 className="about-title1">
            We're On A Mission To Change <br />
            View Of RealEstate Field.
          </h2>

          <p className="about-description">
            We redefine luxury living with modern architecture,
            secure investments and premium properties designed
            for future generations.
          </p>

          {/* FEATURES */}
          <div className="about-features">

            <div className="feature-box">
              <FaHome className="feature-icon" />
              <div>
                <h4>Modern Villa</h4>
                <p>Luxury designed homes with world-class interiors.</p>
              </div>
            </div>

            <div className="feature-box">
              <FaShieldAlt className="feature-icon" />
              <div>
                <h4>Secure Payment</h4>
                <p>Trusted transactions with complete transparency.</p>
              </div>
            </div>

          </div>

          <a href="/about" className="learn-more">
            → Learn More
          </a>
        </div>

      </div>
    </section>
  );
}